var React = require('react');

function IonIosArrowRoundUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M348.3 216.4c-5 5.1-13.3 5.1-18.4.1L269 155.8v231.3c0 7.1-5.8 12.9-13 12.9s-13-5.8-13-12.9V155.8l-60.9 60.8c-5.1 5-13.3 4.9-18.4-.1-5-5.1-5-13.2.1-18.3l83-82.4c1.2-1.1 2.5-2 4.1-2.7 1.6-.7 3.3-1 5-1 3.4 0 6.6 1.3 9.1 3.7l83 82.4c5.2 4.9 5.3 13.1.3 18.2z"}));
}

IonIosArrowRoundUp.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = IonIosArrowRoundUp;

IonIosArrowRoundUp.default = IonIosArrowRoundUp;
